import { ScoreGauge, TonePill } from "./ScoreGauge";
import { ShieldCheck, TrendingUp, TrendingDown } from "lucide-react";

export const SourceBadge = ({ national }) => (
  <div data-testid="sources-transparency-statement" className="inline-flex items-center gap-2 rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-medium text-sky-900">
    <ShieldCheck size={14} /> Independent + Mainstream sources
    {national && <span className="font-mono text-sky-700">· {national.mainstream_count} / {national.independent_count}</span>}
  </div>
);

export const NationalCard = ({ national, periodLabel }) => {
  if (!national) return <div className="h-56 animate-pulse rounded-3xl bg-white" />;
  const d = national.delta;
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8" data-testid="national-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-sky-800" data-testid="ripple-score-label">News tone · Canada · {periodLabel}</p>
        <TonePill score={national.score} testId="national-tone-pill" />
      </div>
      <div className="mt-4 flex items-end gap-3">
        <span data-testid="national-score-badge" className="font-serif text-6xl leading-none text-slate-900 sm:text-7xl">{Math.round(national.score)}</span>
        <span className="mb-2 text-sm text-slate-500">/ 100</span>
        {d !== null && d !== undefined && (
          <span data-testid="national-delta" className={`mb-2 ml-auto inline-flex items-center gap-1 text-sm ${d >= 0 ? "text-emerald-700" : "text-rose-600"}`}>
            {d >= 0 ? <TrendingUp size={16} /> : <TrendingDown size={16} />} {d > 0 ? "+" : ""}{d}
          </span>
        )}
      </div>
      <div className="mt-6"><ScoreGauge score={national.score} height="h-3" testId="national-gauge-bar" /></div>
      <div className="mt-2 flex justify-between text-[11px] uppercase tracking-wider text-slate-400"><span>Concern</span><span>Neutral</span><span>Positive</span></div>
      <p className="mt-5 text-sm text-slate-600">
        Based on <span className="font-mono text-slate-800">{national.article_count}</span> headlines ·{" "}
        <span className="text-emerald-700">{national.positive_signals} constructive</span> vs{" "}
        <span className="text-rose-600">{national.negative_signals} difficult</span> signals.
      </p>
    </div>
  );
};
